import { useEffect, useCallback, useState } from "react";
import 'styles/quotedelivery.css';
import api from "api";

const QuoteDeliveryLine = (
    {
        desc,
        value,
        handleChange
    }
) => {

    return (
        <>
            <span>{desc}</span>
            <input
                type="text"
                onChange={handleChange}
                value={value}
            />
        </>
    );
};


const QuoteDelivery = (
    {
        setDelivery,
        selectedQuote,
    }
) => {

    const [ values, setValues ] = useState({});

    // fonction pour quitter le mode frais de transport
    const handleClick = useCallback(() => {
        api.put(`delivery/${selectedQuote.id}/set`, { values : values });
        setDelivery(false)
    }, [setDelivery, selectedQuote.id, values]);
    
    // fonction pour traiter la touche ECHAP
    const handleKey = useCallback((e) => {
        if (e.key === 'Escape') {
            handleClick();
        }
    }, [handleClick]);

    // fonction pour intercepter le clavier
    useEffect(() => {
        document.addEventListener('keydown',handleKey);
        return () => { 
            document.removeEventListener('keydown',handleKey);
        }
    },[handleKey]);

    // récupère les données
    useEffect(()=>{
        if (selectedQuote) {
            api.get(`delivery/${selectedQuote.id}/get`)
            .then((response)=>{
                var new_values = {};
                response.data.map((obj)=> new_values[obj.desc]=parseFloat(obj.price));
                setValues(new_values);
            });
        }
    },[selectedQuote]);
    

    const lines = [
        "Livraison 3m3",
        "Livraison 12m3",
        "Livraison 40m3",
        "Enlèvement 3m3",
        "Enlèvement 12m3",
        "Enlèvement 40m3",
        "Transport 3m3",
        "Transport 12m3",
        "Transport 40m3",
    ]

    const handleInputChange = useCallback((desc) => (e) => {
        const value = e.target.value;
        const regex = /^\d*(\.\d{0,2})?$/;
        setValues((prev) => {
            if (value === "") {
                const { [desc]: _, ...rest } = prev;
                return rest;
            } else if (regex.test(value)) {
                return {
                    ...prev,
                    [desc]: value,
                };
            }
            return prev;
        });
    }, []);

    return (
            selectedQuote
            &&
            <div
                id="QuoteDelivery"
            >
                <h1>DEVIS {selectedQuote.id}</h1>
                <h2>{selectedQuote.event}</h2>   
                <h3>Frais de transport</h3>
                <div
                    id="QuoteDeliveryBlock"
                >
                    { lines.map( (l) => < QuoteDeliveryLine
                        desc = {l}
                        key = {l}
                        value = {values[l]}
                        handleChange= {handleInputChange(l)}
                    />)}
                </div>
            </div>
    );
};

export default QuoteDelivery;